import { handlers, config } from '_helpers';
import crFetch from '_helpers/fetch';

const { handleResponseAsync } = handlers;
const API = config.apiUrl.reportingAPI;

async function search(props) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'POST',
        url: '/reportDefinitions/search',
        body: JSON.stringify(props),
      }, API))
  );
}

async function getById(reportDefinitionID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/reportDefinitions/${reportDefinitionID}`
      }, API))
  );
}

async function create(reportDefinition) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'POST',
        url: '/reportDefinitions',
        body: JSON.stringify({ reportDefinition })
      }, API))
  );
}

async function update(reportDefinition) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'PUT',
        url: `/reportDefinitions/${reportDefinition.reportDefinitionID}`,
        body: JSON.stringify({ reportDefinition })
      }, API))
  );
}

async function Delete(reportDefinitionID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'DELETE',
        url: `/reportDefinitions/${reportDefinitionID}`
      }, API))
  );
}

const reportDefinitionService = {
  search,
  getById,
  create,
  update,
  delete: Delete
};

export default reportDefinitionService;
